/* eslint-disable import/prefer-default-export */
import { IAppConfig } from '../../../types/appConfig'

export const INITIAL_STATE: IAppConfig[] = [
  {
    id: '02',
    appTitle: 'KFamily - Demonstre compaixão àqueles que estiveram consigo.',
    appFavicon:
      'https://res.cloudinary.com/kfamily-is1/image/upload/v1741376279/Frame_10_b5dbrh.png',
    appDescription:
      'Entregar memórias e afeto, para que nunca sejam esquecidos.',
    appLogo:
      'https://res.cloudinary.com/kfamily-is1/image/upload/v1741437188/Frame_10_hgqu7f.webp',
    appLabel: 'Nosso lema',
    appRoutes: [
      {
        id: '01',
        name: 'Inicio',
        path: '/',
      },
      {
        id: '02',
        name: 'Como funciona',
        path: '/#about-us',
      },
      {
        id: '03',
        name: 'Benefícios',
        path: '/#projects',
      },
      {
        id: '04',
        name: 'Porque nós',
        path: '/#contacto',
      },
    ],
    appActionLabel: 'Fale conosco',
    appActionOutlineLabel: 'Entender melhor',
    appHeroExtraLabels: ['Afeto', 'Famílias', 'Memórias', 'Amigos', 'SMS'],
    styles: {
      primaryColor: '#619978',
      primaryContrastColor: '#ffffff',
      backgroundColor: '#eaf7f8',
      secondaryColor: '#619978',
      forceSecondaryColor: true,
    },
    services: {
      title: 'Você terá uma resposta assim que demonstrar suas condolências',
      label: 'É tudo feito na hora!',
      since: '5',
      image: '',
      actionNextLabel: 'Ver mais',
      serviceList: [
        {
          id: '01',
          title: 'Você envia uma mensagem',
          description:
            'Começaremos a preparar tudo! Mas antes de finalizar, vamos precisar que você confirm que não é um robô e suas intensões são legitimas.',
        },
        {
          id: '02',
          title: 'Você confirma sua intensão',
          description:
            'Pronto. Você agora irá receber as instruções finais de como finalizar. É mais simples do que parece!',
        },
        {
          id: '03',
          title: 'Pronto! Sua mensagem será entregue!',
          description:
            'É isso, a Família provavelmente já foi notificada da sua mensagem! Em alguns dias, a mesma será entregue na reseidência da Família.',
        },
      ],
    },
    specialties: {
      title:
        'Estreitamos caminhos para a entregua de mensagens de condolências',
      label: 'Fazemos uma grande diferença',
      image: '',
      actionNextLabel: 'Veja os items',
      specialtiesList: [
        {
          id: '01',
          title: 'Empatia por meio da inovação',
          image: '',
          description:
            'A KFamily combina compaixão com tecnologia para garantir que mensagens de condolências sejam entregues com cuidado, preenchendo lacunas emocionais durante momentos de perda.',
        },
        {
          id: '02',
          title: 'Processo de mensagens sem interrupções',
          image: '',
          description:
            'Enviar condolências é simples com a KFamily: envie sua mensagem, receba a confirmação e nós garantimos que ela chegue ao destinatário certo de forma rápida e segura.',
        },
        {
          id: '03',
          title: 'Construindo conexões entre comunidades',
          image: '',
          description:
            'A KFamily promove o apoio ajudando famílias e empresas a enviar facilmente mensagens de simpatia, fortalecendo os laços em momentos difíceis.',
        },
        {
          id: '04',
          title: 'Entrega confiável, sempre',
          image: '',
          description:
            'Confie na KFamily para entrega segura e oportuna de mensagens de condolências, tratadas com respeito e profissionalismo em todas as etapas.',
        },
      ],
    },
    testimonials: {
      title: 'Veja o que alguns clientes já falaram sobre nós',
      label: 'O que dizem de nós',
      actionNextLabel: 'Ver mais',
      testemonialList: [
        {
          id: '',
          personFullName: 'William Silva',
          personPosition: 'Fundador da Funerária Ficticia',
          personImage: '',
          description:
            'A KFamily mudou a forma do que faziamos, a gama de serviços que podemos utilizar é enorme e incrível. Facilitou imensou alguns de nosos processos e possui uma equipa exelente!',
          descriptionImages: '',
        },
        {
          id: '',
          personFullName: 'William Silva 2',
          personPosition: 'Fundador da Funerária Ficticia',
          personImage: '',
          description:
            'A KFamily mudou a forma do que faziamos, a gama de serviços que podemos utilizar é enorme e incrível. Facilitou imensou alguns de nosos processos e possui uma equipa exelente!',
          descriptionImages: '',
        },
      ],
    },
    contacts: {
      label: 'Entre em contacto',
      title: 'Onde você falar, vamos te responder',
      description:
        'Aqui estão algumas opções de como você pode entrar em contato conosco e tirar todas as suas dúvidas.',
      telephone: 'Ligue diretamente:',
      telephoneLabel: '+351 910 774 611',
      email: 'geral@kfamily.pt',
      emailLabel: '24h, 7 dias da semana.',
      openHours: 'Horário da loja física:',
      openHoursLabel: '9:00 - 18:00',
      location: 'Localização:',
      locationLabel: 'Rua do Pinheiro, 701, Braga, Portugal',
      form: {
        fullNameLabel: 'Seu nome:',
        phoneNumberLabel: 'Seu celular:',
        emailLabel: 'Seu email:',
        messageLabel: 'Sua mensagem',
        messagePlaceholder: 'Escreva sua mensagem',
        actionSubmit: 'Enviar Mensagem',
      },
    },
    footer: {
      rightsLabel:
        'KFamily - Inovação e Tecnologia 2025 | Todos os direitos reservados.',
      termsAndConditionsLabel: 'Termos & Condições',
      privacyPolicy: 'Política de Privacidade',
      contactUs: 'Contatos',
    },
  },
]
